export default __webpack_public_path__ + "../staticImages/sprite-trusted-shopsm.png";